/**
 * Man Trail as a responsibility spec — pure man-to-man, no zone escape.
 *
 * The Cover 3 trips weak corner: "straight man-to-man on the single WR, no exceptions." There
 * is nothing to read, so the spec has no latches and no transitions — he starts in MAN and
 * stays there. It is a spec anyway so it inherits the shared perception path: before migration
 * this policy indexed the feed directly and therefore reacted with ZERO latency, unlike every
 * other defender on the field.
 *
 * See `.kiro/steering/cover3Match.md`.
 */

import { ManTrailParams } from '../../types';
import { ResponsibilitySpec } from '../responsibility';

const trail = ({ key, params, defender }: {
  key: { position: { x: number; y: number } };
  params: ManTrailParams;
  defender: { x: number; y: number };
}) => ({
  // Trail from behind, but NEVER give up depth to get there. At the snap the key is still
  // shallower than the defender, so a raw `key.y + cushion` target would send him running back
  // toward the LOS just to fall in behind, then force a full reversal when the key runs past.
  target: { x: key.position.x, y: Math.min(defender.y, key.position.y + params.trailCushion) },
  speed: params.maxSpeed,
});

export const MAN_TRAIL_SPEC: ResponsibilitySpec<ManTrailParams> = {
  id: 'man-trail',
  initialTechnique: 'backpedal',
  initialState: 'MAN',
  transitions: [], // nothing can talk him off his man
  behavior: { READ: trail, MAN: trail, ZONE: trail },
};
